import buildSimpleStringFilter from '../buildSimpleStringFilter'

const TransportModeFilter = buildSimpleStringFilter({
  key: 'transportMode',
  expandedOnInit: false,
})

export default TransportModeFilter
